import { UseProcessorData } from '../../hooks';
import { ProcessorDataContext, ProcessorDataProviderProps } from '../processor-data.context';

export const ProcessorDataPublicProvider = ({ children }: ProcessorDataProviderProps) => {
  const value = {} as UseProcessorData;
  console.warn('TODO: Need to figure out public endpoints for this');

  return <ProcessorDataContext.Provider value={value}>{children}</ProcessorDataContext.Provider>;
};
